<div class="d-sm-flex align-items-center mb-4">
  <h1 class="h2 mb-4 mb-sm-0 me-4">Comenzi</h1>
  <div class="d-flex ms-auto">
    <div *ngIf="pdfScriptsLoaded" ngbDropdown class="dropdown ms-auto me-2">
      <button ngbDropdownToggle type="button" class="btn btn-secondary dropdown-toggle">
        <i class="ai-download me-2 ms-n1"></i>Exporta
      </button>
      <ul ngbDropdownMenu class="dropdown-menu my-1">
        <li><a ngbDropdownItem (click)="exportAsPdf()" class="dropdown-item" role="button">PDF</a></li>
        <li><a ngbDropdownItem (click)="exportAsExcel()" class="dropdown-item" role="button">Excel</a></li>
      </ul>
    </div>
    <select [(ngModel)]="filter" (ngModelChange)="onFilterChange()" class="form-select">
      <option value="all">Toate comenzile</option>
      <option value="last-week">Ultima saptamana</option>
      <option value="last-month">Ultima luna</option>
      <option value="pending">In asteptare</option>
      <option value="processing">In procesare</option>
      <option value="failed">Esuate</option>
      <option value="completed">Finalizate</option>
    </select>
  </div>

</div>
<div class="card border-0 py-1 p-md-2 p-xl-3 p-xxl-4">
  <div class="card-body pb-4">
    <!-- Orders-->
    <ng-container *ngIf="orders">
      <gs-order-list [orders]="filteredOrders" [itemsPerPage]="10"></gs-order-list>
    </ng-container>

    <!-- No items -->
    <div *ngIf="orders?.length === 0" class="card border-0 bg-secondary text-center">
      <svg-icon src="assets/images/illustrations/no-data.svg" svgClass="w-50 h-50 mt-3"></svg-icon>
      <div class="card-body">
        <h4 class="card-title">Nicio inregistrare</h4>
        <p class="card-text">Nu exista comenzi de carduri cadou pe contul tau. Doresti sa plasezi o comanda noua?</p>
        <div ngbDropdown class="btn-group w-100 w-sm-auto mb-2 mb-sm-0">
          <button ngbDropdownToggle type="button" class="btn btn-outline-primary dropdown-toggle">
            Afla mai multe
          </button>
          <ul ngbDropdownMenu class="dropdown-menu my-1">
            <li><a ngbDropdownItem [routerLink]="['/cum-functioneaza']" class="dropdown-item" role="button">Cum
                functioneaza</a>
            </li>
            <li><a ngbDropdownItem [routerLink]="['/intrebari-frecvente']" class="dropdown-item" role="button">Intrebari
                frevente</a></li>
          </ul>
        </div>
        <div ngbDropdown class="btn-group w-100 w-sm-auto ms-sm-2">
          <button ngbDropdownToggle type="button" class="btn btn-primary dropdown-toggle">
            Ofera un cadou
          </button>
          <ul ngbDropdownMenu class="dropdown-menu my-1">
            <li><a ngbDropdownItem [routerLink]="['/user/creare-eveniment']" class="dropdown-item" role="button">Ofera
                un cadou de grup</a>
            </li>
            <li><a ngbDropdownItem [routerLink]="['/carduri-cadou']" class="dropdown-item" role="button">Ofera un card
                cadou GiftShare</a></li>
          </ul>
        </div>
      </div>
    </div>

    <!-- No filter results template -->
    <div *ngIf="orders?.length > 0 && filteredOrders?.length === 0" class="card border-0 bg-secondary text-center">
      <svg-icon src="assets/images/illustrations/no-search-results.svg" svgClass="w-50 h-50 mt-3"></svg-icon>
      <div class="card-body">
        <h4 class="card-title">Nicio inregistrare</h4>
        <p class="card-text">Ne pare rau, nu a fost gasit niciun rezultat care sa corespunda cautarii.</p>
      </div>
    </div>

    <!-- Loading template -->
    <div *ngIf="!orders">
      <div *ngFor="let item of [].constructor(5); last as last" [ngClass]="{'border-bottom': last}"
        class="border-top placeholder-glow py-2" aria-hidden="true">
        <span class="placeholder placeholder-lg col-3 me-2"></span>
        <span class="placeholder placeholder-lg col-4 me-2"></span>
        <span class="placeholder placeholder-lg col-3"></span>
        <span class="placeholder col-2 me-2"></span>
        <span class="placeholder col-9"></span>
      </div>
    </div>

  </div>
</div>
